import React from "react";
import ReactDOM from "react-dom/client";
import "@/fonts/fonts.css";
import "@/index.css";
import App from "@/App";
import { initTextScale } from "@/lib/textScale";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

// Antes de pintar: el tamaño de texto guardado (sin parpadeo al cargar)
initTextScale();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Nueva versión desplegada: se activa el service worker nuevo y se recarga
// cuando ya controla la página. Antes se recargaba al instante, a la vez que
// se activaba: la recarga podía servirse aún con el index.html viejo, cuyos
// chunks el service worker nuevo borra al activarse (ChunkLoadError al
// navegar, y la pantalla de "actualización").
serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    const waiting = registration && registration.waiting;
    if (!waiting) return;
    let reloading = false;
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (reloading) return;
      reloading = true;
      window.location.reload();
    });
    waiting.postMessage({ type: "SKIP_WAITING" });
  },
});
